import { ROUTES } from '../lib/routes';
import { showToast } from '../components/toast';
import { el } from '../utils/dom';
import { fetchMyApplicationHistory } from '../api/myHistory';

function statusLabel(status: string): string {
  const m: Record<string, string> = {
    submitted: '접수',
    in_review: '검토중',
    completed: '완료',
    approved: '승인',
    rejected: '반려',
    open: '진행중',
    answered: '답변완료',
    closed: '종료',
  };
  return m[status] ?? status;
}

export function renderMyApplicationsPage(root: HTMLElement): void {
  const wrap = el('div', {});

  wrap.append(
    el('div', { className: 'ev123-page-head' }, [
      el('div', { className: 'ev123-container' }, [
        el('h1', { className: 'ev123-page-head__title', text: '신청내역 조회' }),
        el('p', {
          className: 'ev123-page-head__lead',
          text: '상담·제품·문의 신청 내역을 한곳에서 확인합니다.',
        }),
      ]),
    ])
  );

  const container = el('div', { className: 'ev123-container' });
  const card = el('div', { className: 'ev123-card' });

  const toolbar = el('div', {
    style: 'display:flex;justify-content:flex-end;gap:0.5rem;margin-bottom:1rem;flex-wrap:wrap',
  });
  const profileBtn = el('a', {
    className: 'ev123-btn ev123-btn--header-subtle ev123-btn--sm',
    href: ROUTES.myProfile,
    'data-nav': '',
  }) as HTMLAnchorElement;
  profileBtn.textContent = '내 프로필';
  toolbar.appendChild(profileBtn);
  card.appendChild(toolbar);

  const listHost = el('div', { className: 'ev123-history-list' });
  const loading = el('p', { className: 'ev123-muted', text: '불러오는 중…' });
  listHost.appendChild(loading);
  card.appendChild(listHost);

  container.appendChild(card);
  wrap.appendChild(container);
  root.appendChild(wrap);

  fetchMyApplicationHistory()
    .then((rows) => {
      listHost.replaceChildren();
      if (rows.length === 0) {
        listHost.append(
          el('div', { className: 'ev123-empty-state' }, [
            el('p', {
              className: 'ev123-empty-state__text',
              text: '아직 접수된 신청 내역이 없습니다. 승인 후 포털에서 상담·제품 신청을 이용하실 수 있습니다.',
            }),
            (() => {
              const hint = el('p', { className: 'ev123-field-hint', style: 'margin:0.5rem 0 0' });
              const a = el('a', { href: ROUTES.consult, 'data-nav': '' }) as HTMLAnchorElement;
              a.textContent = '비로그인 상담 신청(익명)';
              hint.append(a, document.createTextNode(' 은 언제든 이용 가능합니다.'));
              return hint;
            })(),
          ])
        );
        return;
      }

      for (const r of rows) {
        const row = el('div', { className: 'ev123-history-row' });
        row.append(
          el('div', { className: 'ev123-history-row__meta' }, [
            el('span', { className: 'ev123-history-row__cat', text: r.category }),
            el('span', { className: 'ev123-history-row__date', text: r.createdAt ?? '—' }),
          ]),
          el('div', { className: 'ev123-history-row__title', text: r.title }),
          el('div', {
            className: 'ev123-history-row__status',
            text: `상태: ${statusLabel(r.status)}`,
          })
        );
        listHost.appendChild(row);
      }
    })
    .catch((e) => {
      listHost.replaceChildren();
      const msg = e instanceof Error ? e.message : '목록을 불러오지 못했습니다.';
      showToast(msg);
      listHost.append(
        el('p', { className: 'ev123-field-hint', text: '목록을 불러오지 못했습니다. 다시 시도해 주세요.' })
      );
    });
}
